import { render, staticRenderFns } from "./PhotoAlbum.vue?vue&type=template&id=55437762&scoped=true&"
import script from "./PhotoAlbum.vue?vue&type=script&lang=js&"
export * from "./PhotoAlbum.vue?vue&type=script&lang=js&"
import style0 from "./PhotoAlbum.vue?vue&type=style&index=0&id=55437762&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55437762",
  null
  
)

export default component.exports